export const FTP_CONNECT = 'FTP_CONNECT'
export const FTP_GET = 'FTP_GET'
export const FTP_PUT = 'FTP_PUT'
export const FTP_DELETE = 'FTP_DELETE'
export const FTP_MGET = 'FTP_MGET'
export const FTP_MPUT = 'FTP_MPUT'
export const FTP_M_DELETE = 'FTP_M_DELETE'
export const FTP_R_MOVE_FILES = 'FTP_R_MOVE_FILES'
export const FTP_R_MOVE_FILE = 'FTP_R_MOVE_FILE'
export const FTP_CREATE_FOLDER = 'FTP_CREATE_FOLDER'
export const FTP_DELETE_FOLDER = 'FTP_DELETE_FOLDER'